import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalTitle: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.welcome-modal.modal-title',
		defaultMessage: 'Welcome to ‘Your work’',
		description:
			'Modal title text - for an onboarding tour that appears when a first time user lands in the ‘Your Work’ section of JSM',
	},
	modalContentLine: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.welcome-modal.modal-content-line',
		defaultMessage:
			'This is the overview for your projects. When you create projects, or you’re added to someone else’s, you’ll see them all here.',
		description:
			'Modal content text - for an onboarding tour that appears when a first time user lands in the ‘Your Work’ section of JSM',
	},
	next: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.welcome-modal.next',
		defaultMessage: 'Next',
		description:
			'Button to goto the next step of the tour - for an onboarding tour that appears when a first time user lands in the ‘Your Work’ section of JSM',
	},
	skip: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.welcome-modal.skip',
		defaultMessage: 'Skip',
		description:
			'Button to skip the rest of the tour - for an onboarding tour that appears when a first time user lands in the ‘Your Work’ section of JSM',
	},
	modalImageAltText: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.welcome-modal.modal-image-alt-text',
		defaultMessage: 'Welcome to ‘Your Work’',
		description:
			'Alt text for modal hero image - for an onboarding tour that appears when a first time user lands in the ‘Your Work’ section of JSM',
	},
});
